module.exports = __webpack_public_path__ + "img/1515064560.ef0370ba.jpg";